import { BorderRadius } from 'app/shared/theme/common/typings';

export const borderRadius: BorderRadius = {
  input: '2px',
  modal: '2px',
  card: '2px',
  radioDetailOption: '4px',
  eventCard: '4px',
};
